import { render } from "./PublicidadeView.vue?vue&type=template&id=19c24150&scoped=true"
import script from "./PublicidadeView.vue?vue&type=script&lang=js"
export * from "./PublicidadeView.vue?vue&type=script&lang=js"

import "./PublicidadeView.vue?vue&type=style&index=0&id=19c24150&scoped=true&lang=css"

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19c24150"]])

export default __exports__